import { useEffect } from "react";
import { BigLogo } from "../../assets/icons";
import LayoutWrapper from "../../layouts/landing-page-layout-wrapper/layoutWrapper";
import styles from "./terms.module.scss";
import { PrivacyPolicyContent } from "./PrivacyPolicyContent";

const PrivacyPolicyPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<BigLogo height={300} className={styles.image} />
				<LayoutWrapper>
					<div className={styles.headerTextWrapper}>
						<h2 className={styles.headerText}>Privacy Policy for Eko Power app</h2>
						<p className={styles.subHeader}>
							<strong>Effective Date:</strong> 28th February, 2026
						</p>
					</div>
				</LayoutWrapper>
			</div>
			<LayoutWrapper>
				<div className={`${styles.termsBody} ${styles.privacyWrapper}`}>
					<PrivacyPolicyContent />
				</div>
			</LayoutWrapper>
		</div>
	);
};
export default PrivacyPolicyPage;
